import contratoImg from '../../../assets/CedulaContrato.png';

const labelStyle = "margin-top: 5px; font-weight: bold; font-size: 16px;";
const labelStyleMt = "margin-top: 10px; font-weight: bold; font-size: 16px;";

export const getVincularContratoHtml = ({ showWarning = false } = {}) => {
  const warningBlock = showWarning
    ? `<div style="margin: 16px 14px 0; padding: 10px 14px; background-color: #fff8e1; border-left: 4px solid #f8cf3f; border-radius: 4px; color: #5a4000; font-size: 14px; text-align: left;">
        <strong>Advertencia:</strong> Al continuar con este proceso toda acción que se realice por el usuario quedará registrada en el historial de la plataforma.
       </div>`
    : '';

  return (
    `<h5 style="${labelStyle}">Contrato de facturación</h5>` +
    `<input id="subs" class="swal2-input" placeholder="Número de Contrato/Suscriptor *" style="width: 60%; color: black;">` +
    `<h5 style="${labelStyleMt}">Número de identificación en la factura</h5>` +
    `<input id="docu" class="swal2-input" placeholder="Identificación/Documento *" style="width: 60%; color: black;">` +
    `<div style="display:flex;flex-direction:column;align-items:center;margin-bottom:10px;">` +
      `<span style="font-size:17px;color:#444;padding:10px;font-weight:bold;">¿Dónde encontrar el número de contrato y de identificación?</span>` +
      `<img src="${contratoImg}" alt="Ubicación contrato y número de ID" style="width:auto;height:auto;margin-bottom:10px;border-radius:8px;box-shadow:0 20px 20px #0001" />` +
      `<div style="margin-top:10px;font-size:15px;color:#528711;">` +
        `¿No cuentas con factura digital? ` +
        `<a href="https://www.emcali.com.co/web/guest/registrarse" target="_blank" rel="noopener noreferrer" style="color:#4a1272;font-weight:bold;text-decoration:underline;cursor:pointer;">Haz el registro aquí</a>` +
      `</div>` +
    `</div>` +
    warningBlock
  );
};
